import { render, staticRenderFns } from "./AtencionesModalVerDetalle.vue?vue&type=template&id=4f931800&"
import script from "./AtencionesModalVerDetalle.vue?vue&type=script&lang=ts&"
export * from "./AtencionesModalVerDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./AtencionesModalVerDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4f931800', component.options)
    } else {
      api.reload('4f931800', component.options)
    }
    module.hot.accept("./AtencionesModalVerDetalle.vue?vue&type=template&id=4f931800&", function () {
      api.rerender('4f931800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Atenciones/AtencionesModalVerDetalle.vue"
export default component.exports